<div class="modal"
     [class.modal_large]="(isMobile$ | async) === false"
     [ngClass]="{'is-full': isShowFull}">
  <span class="modal__close ngdialog-close" (click)="$event.stopPropagation(); close()">
    <i class="material-icons">close</i>
  </span>
  <div class="modal-header">
    <div class="invoice__date" *ngIf="inputInvoice?.dateTime || inputInvoice?.DateTime">
      Створена: {{ createdDate | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss" }}
      <span *ngIf="inputInvoice?.Number" class="invoice__date-hint">{{ inputInvoice?.note }}</span>
    </div>
    <div class="invoice-header">
      <div class="invoice-header__left">
        <mat-icon class="material-icons invoice-header__icon-type">bookmark_added</mat-icon>
        <div class="invoice-header__number copy-content copy-content_lg">{{ formattedInvoiceNumber }}
          <button mat-icon-button class="copy-content__btn"
                  [appCopy]="inputInvoice?.docNumber"
                  [matTooltip]="'Скопіювати'" matTooltipPosition="below">
            <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <main class="modal-content modal-content_pad-none">
    <mat-progress-bar [style.opacity]="+(loading$ | async)" mode="indeterminate">
    </mat-progress-bar>
    <div class="invoice">
      <app-simple-banner class="simple-banner">
        <ng-container title>Відстеження посилки</ng-container>
        <ng-container text>
          Зверніть увагу, що посилка не належить користувачу кабінету, проте Ви можете відслідковувати її статус.
        </ng-container>
      </app-simple-banner>

      <app-simple-banner *ngIf="(inputInvoice?.deliveryPrice !== inputInvoice?.SumBeforeCheckWeight && inputInvoice?.SumBeforeCheckWeight > 0) || inputInvoice?.CalculatedWeight > 0"
                         [type]="BannerType.Warning"
                         class="simple-banner">
        <ng-container title>Вагу відправлення змінено</ng-container>
        <ng-container text>
          <ng-container *ngIf="inputInvoice?.CalculatedWeight > 0">
            За результатами контрольного зважування фактична вага вашої посилки була оновлена.
          </ng-container>
          <ng-container *ngIf="(inputInvoice?.deliveryPrice !== inputInvoice?.SumBeforeCheckWeight && inputInvoice?.SumBeforeCheckWeight > 0)">
            У разі незгоди з результатом ви можете самостійно перезважити посилку в момент її отримання.
          </ng-container>
        </ng-container>
      </app-simple-banner>
      <div class="invoice-body">
        <div class="invoice-body__left">
          <app-invoice-progress-state *ngIf="inputInvoice?.state"
                                      [stateColor]="inputInvoice.state.color"
                                      [progressPercent]="inputInvoice.state.progressPercent"
                                      [showNote]="inputInvoice.state.showNote"
                                      [informerPosition]="inputInvoice.state.informerPosition"
                                      [informerIcon]="inputInvoice.state?.informerIcon"
                                      [informerDate]="invoiceStateInformerDate"
                                      [informerText]="inputInvoice.state.name"
                                      [startLocation]="SenderAddressDescription"
                                      [endLocation]="RecipientAddressDescription"
                                      [dateFirstDayStorage]="inputInvoice?.dateFirstDayStorage"
                                      [dateReturnCargo]="inputInvoice?.dateReturnCargo">
            <ng-container startPoint>
              Дата
              виїзду: {{ (inputInvoice?.createTime | np_to_date_format | date :"dd.MM.yyyy") || (inputInvoice?.DateTime | np_to_date_format | date :"dd.MM.yyyy") || '&mdash;' }}
            </ng-container>

            <ng-container endPoint>
              <div
                *ngIf="inputInvoice?.state?.id !== '4' && inputInvoice?.state?.id !== '5' && inputInvoice?.state?.id !== '0' && inputInvoice?.state?.id !== '6'">
                Плановий час доставки: {{ inputInvoice?.scheduleDeliveryDate | np_to_date_format | deliveryDate }}
              </div>
              <div
                *ngIf="inputInvoice?.state?.id === '5' && inputInvoice?.receivingTime && inputInvoice?.receivingTime">
                Дата
                отримання: {{ (inputInvoice?.receivingTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss") || (inputInvoice?.receivingTime | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss") }}
              </div>
              <div *ngIf="!invoice?.state?.showNote && invoice?.state?.note">
                {{ invoice?.state?.note }}
              </div>
            </ng-container>

            <ng-container processInformer>
              <app-invoice-transport-process-informer
                [invoice]="getStatusDocumentsInvoice">
              </app-invoice-transport-process-informer>
            </ng-container>
          </app-invoice-progress-state>
        </div>
      </div>
      <div class="invoice-services"
           *ngIf="inputInvoice?.backDeliveryPayer || !!inputInvoice?.paymentControl">
        <div class="invoice-services__title">Додаткові послуги</div>
        <div class="invoice-services__item wrap" *ngIf="inputInvoice?.backDeliveryPayer">
          <ng-container *ngIf="backMoney">
            <div class="invoice-services__name nowrap-text">
              <i class="material-icons invoice-services__icon">reply</i>
              <span>Зворотна доставка: {{ (inputInvoice?.backMoney + ' грн') || '0' }}</span>
            </div>
            <div class="invoice-services__text nowrap-text" *ngIf="inputInvoice?.Cash2CardPAN === ''">
              <span *ngIf="inputInvoice?.backMoney">Вартість доставки: {{ paymentSum + ' грн' }} &nbsp;&nbsp;•</span>&nbsp;&nbsp;
            </div>
            <div class="invoice-services__text nowrap-text">Платник за
                                                            послугу: {{ (payerNameTranslations[inputInvoice?.backDeliveryPayer]) }}
            </div>
            <div class="invoice-services__text nowrap-text" *ngIf="type === 'out'">
              • Тип доставки: {{
                ((inputInvoice?.moneyTransferCash2Card)
                  ? 'На картку ' + inputInvoice?.cardMaskedNumber
                  : 'У відділення')
              }}
            </div>
          </ng-container>
        </div>
        <div class="invoice-services__item" *ngIf="!!inputInvoice?.paymentControl">
          <i class="material-icons invoice-services__icon">reply</i>
          <span class="invoice-services__name">Контроль оплати:
            {{ (inputInvoice?.paymentControl) + ' грн' }}</span>
        </div>
        <div class="invoice-services__item" *ngIf="!!inputInvoice?.AccompanyingDocuments">
          <div class="invoice-services__name d-flex w-100 nowrap-text align-items-center">
            <i class="material-icons invoice-services__icon">description</i>
            <span
              class="text-overflow-ellipsis">Супроводжуючі документи: {{ inputInvoice?.AccompanyingDocuments }}</span>
          </div>
        </div>
      </div>

      <div class="invoice__payment">
        <div class="info-row invoice__row">
          <div class="info-row__left">
            <div class="info-row__col">
              <div class="info-cell info-row__cell">
                <div class="info-cell__label">Вартість доставки</div>

                <div *ngIf="inputInvoice?.deliveryPrice !== inputInvoice?.SumBeforeCheckWeight"
                     class="info-cell__content info-cell__content_lg">
                  <span class="line-through-text">{{ inputInvoice?.SumBeforeCheckWeight }}</span>
                  {{ invoiceCost }}
                </div>

                <div *ngIf="inputInvoice?.deliveryPrice === inputInvoice?.SumBeforeCheckWeight
                         && !checkIfPaid(paymentCostsInfo)
                         || inputInvoice?.lastCreatedOnTheBasisDocumentType"
                     class="info-cell__content info-cell__content_lg">
                  {{ invoiceCost }}
                </div>

                <div *ngIf="inputInvoice?.deliveryPrice === inputInvoice?.SumBeforeCheckWeight
                           && (paymentCostsInfo && checkIfPaid(paymentCostsInfo))
                           && !inputInvoice?.lastCreatedOnTheBasisDocumentType"
                     class="info-cell__content info-cell__content_lg payment-status-cell">
                  <div [class.line-through-text]="!hideIsPaid">
                    {{ invoiceCost }}
                  </div>
                  <ng-container *ngIf="!hideIsPaid">Сплачено</ng-container>
                </div>
              </div>
            </div>

            <div class="info-row__col">
              <div class="info-cell info-row__cell">
                <div class="info-cell__label">Платник за доставку</div>
                <div class="info-cell__content">
                  {{ payerNameTranslations[inputInvoice?.PayerType] || '&mdash;' }}
                </div>
              </div>
            </div>
          </div>
          <div class="info-row__right">
            <div class="info-cell info-row__cell">
              <div class="info-cell__label">Форма оплати за доставку</div>
              <div class="info-cell__content">
                {{ ((paymentMethodTranslations[inputInvoice?.paymentMethod?.id]) || paymentMethodTranslations[inputInvoice?.PaymentMethod]) || '&mdash;' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <np-invoice-tracked-full-info-modal *ngIf="isShowFull" [invoiceFullData]="inputInvoice">
      </np-invoice-tracked-full-info-modal>
      <div class="invoice-return-info" *ngIf="!!(redirectRequest || returnRequest)">
        <div class="invoice-return-info__title" *ngIf="!!returnRequest">Повернення посилки</div>
        <div class="invoice-return-info__title" *ngIf="!!redirectRequest">Переадресування посилки</div>
        <div class="invoice-return-info__location">{{ newInvoice?.recipientAddress?.shortDescription }}</div>
        <button type="button"
                (click)="goToNewInvoice(redirectRequest?.newInvoiceNumber  || returnRequest?.newInvoiceNumber, $event)"
                class="mat-button_transparent matF-button_sm mat-button_uppercase invoice-return-info__btn"
                mat-button color="primary">
          Нова накладна {{ (redirectRequest?.newInvoiceNumber || returnRequest?.newInvoiceNumber) | fineDocNumber }}
        </button>
        <div class="invoice-return-info__total">Вартість
                                                доставки:
          {{ newInvoice?.isInternational
                ? formatCostForInternationalInvoice(newInvoice?.deliveryPrice + newInvoice?.StoragePrice, newInvoice?.DocumentCostCurrencyCode)
                : (newInvoice?.deliveryPrice + newInvoice?.StoragePrice) + ' грн'}}
        </div>
      </div>
    </div>
  </main>
  <div class="modal-footer p-2">
    <div class="modal-footer-buttons">
      <div class="modal-footer-buttons__item">
        <button type="button"
                class="mat-button_with-icon"
                [disableRipple]="true" (click)="switchShowFull()"
                mat-button>
          <mat-icon *ngIf="!isShowFull" class="material-icons_grey button-more__icon">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="isShowFull" class="material-icons_grey button-more__icon">keyboard_arrow_up</mat-icon>
          {{ !isShowFull ? 'Показати більше' : 'Приховати' }}
        </button>
      </div>
      <div class="modal-footer-buttons__item modal-footer-buttons__right">
        <button *ngIf="showBecomePayerButton"
                type="button"
                mat-button
                (click)="becomePayer()">
          <mat-icon class="mr-1">paid</mat-icon>
          Стати платником
        </button>
        <app-donate-button></app-donate-button>
        <button mat-button
                [confirmMsg]="'Ви впевнені, що бажаєте виконати цю дію?'"
                *ngIf="isPresentedInTrackingDocuments(inputInvoice?.docNumber)"
                [confirmBtnText]="'Видалити'"
                [cancelBtnText]="'Скасувати'"
                [matTooltip]="'Видалити'"
                matTooltipPosition="below"
                (confirm)="removeFromTrackingDocuments()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #dash>—</ng-template>
